"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var env_1 = require("../env");
/**
 * prevent drag & copy
 *
 * componentDidMount() {
 *   preventDragAndCopy()
 * }
 *
 * componentWillUnmount() {
 *   allowDragAndCopy()
 * }
 */
var preventDragAndCopy = function () {
    if (env_1.isServer)
        return;
    document.addEventListener('contextmenu', handleEventPreventDefault);
    document.addEventListener('dragstart', handleEventPreventDefault);
    document.addEventListener('selectstart', handleEventPreventDefault);
};
exports.preventDragAndCopy = preventDragAndCopy;
var allowDragAndCopy = function () {
    if (env_1.isServer)
        return;
    document.removeEventListener('contextmenu', handleEventPreventDefault);
    document.removeEventListener('dragstart', handleEventPreventDefault);
    document.removeEventListener('selectstart', handleEventPreventDefault);
};
exports.allowDragAndCopy = allowDragAndCopy;
var handleEventPreventDefault = function (e) {
    if (e.target.type === 'text') {
        return;
    }
    e.preventDefault();
};
//# sourceMappingURL=preventCopy.js.map